import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

const ClockIcon = ({ color, width, height }) => {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 363.025 363.024"
            width={width}
            height={height}
            fill={color}
        >
            <Rect x="175.658" y="40.986" width="11.71" height="134.671" />
            <Path d="M181.512,363.024C81.43,363.024,0,281.601,0,181.513c0-36.373,10.721-71.47,31.003-101.489l9.703,6.559 
      c-18.972,28.075-28.996,60.899-28.996,94.931c0,93.627,76.17,169.802,169.802,169.802c93.627,0,169.803-76.175,
      169.803-169.802c0-91.672-73.02-166.606-163.947-169.702v14.538h-11.71V0h5.854c100.089,0,181.513,81.43,181.513,
      181.513C363.025,281.601,281.601,363.024,181.512,363.024z"/>
        </Svg>
    );
};

export default ClockIcon;
